import { render } from "./DetailWindow.vue?vue&type=template&id=4de21c61"
import script from "./DetailWindow.vue?vue&type=script&lang=js"
export * from "./DetailWindow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__